import { render, staticRenderFns } from "./UserRoleColumnModal.vue?vue&type=template&id=7c0c5372&scoped=true&"
import script from "./UserRoleColumnModal.vue?vue&type=script&lang=js&"
export * from "./UserRoleColumnModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleColumnModal.vue?vue&type=style&index=0&id=7c0c5372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c5372",
  null
  
)

export default component.exports